const utils = {
    // 获取当前操作系统
    getOS() {
        let os;
    
        if (navigator.userAgent.includes('Android') || navigator.userAgent.includes('Linux')) {
        os = 'Android';
        } else if (navigator.userAgent.includes('iPhone')) {
        os = 'iOS';
        } else if (navigator.userAgent.includes('Windows Phone')) {
        os = 'windowsPhone';
        } else {
        os = 'Others';
        }
        return os;
    },
    getUrlParam(paraName) {
        　　　　var url = decodeURI(document.location.toString());
        　　　　var arrObj = url.split("?");

        　　　　if (arrObj.length > 1) {
        　　　　　　var arrPara = arrObj[arrObj.length - 1].split("&");
        　　　　　　var arr;

        　　　　　　for (var i = 0; i < arrPara.length; i++) {
        　　　　　　　　arr = arrPara[i].split("=");

        　　　　　　　　if (arr != null && arr[0] == paraName) {
        　　　　　　　　　　return arr[1];
        　　　　　　　　}
        　　　　　　}
        　　　　　　return "";
        　　　　}
        　　　　else {
        　　　　　　return "";
        　　　　}
        　　},
    setCookie(name, value, timestamp) {
        let date = new Date();
        date.setTime(date.getTime() + timestamp * 1000);
        document.cookie = name + '=' + escape(value) + ";expires=" + date.toGMTString();
        document.cookie = `${name}=${ escape(value) };expires=${ date.toGMTString() }`
    },

    getCookie(name) {
        let arr
        let reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
        if (arr = document.cookie.match(reg)) {
            return unescape(arr[2]);
        }
        else {
            return null;
        }
    },

    delCookie(name) {
        let date = new Date()
        date.setTime(date.getTime() - 1);
        document.cookie = `${name}='';expires=${ date.toGMTString() }`
    },

    dateFormatter(str, ) { //默认返回yyyy-MM-dd HH-mm-ss
        var hasTime = arguments[2] != false ? true : false; //可传第三个参数false，返回yyyy-MM-dd
        var d = new Date(str);
        var year = d.getFullYear();
        var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
        var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();
        var hour = d.getHours() < 10 ? '0' + d.getHours() : d.getHours();
        var minute = d.getMinutes() < 10 ? '0' + d.getMinutes() : d.getMinutes();
        var second = d.getSeconds() < 10 ? '0' + d.getSeconds() : d.getSeconds();
        if (hasTime) {
            return [year, month, day].join('-') + " " + [hour, minute, second].join(':');
        } else {
            return [year, month, day].join('-');
        }
    },

    dateFormatToMD(timestamp) {
        var d = new Date(+timestamp);
        
        var year = d.getFullYear();
        var month = (d.getMonth() + 1) < 10 ? '0' + (d.getMonth() + 1) : (d.getMonth() + 1);
        var day = d.getDate() < 10 ? '0' + d.getDate() : d.getDate();


        return year + '年' + month + '月' + day + '日'
    }
}

export default utils


// WEBPACK FOOTER //
// ./src/utils/utils.js